<div class="switch" appTransitionPreventor>
  <input type="checkbox" id="switch-{{id}}" [(ngModel)]="switchValue" (ngModelChange)="onSwitch.emit(switchValue)"
    [disabled]="(!(permission | permissions : gallery) && (!switchValue || !overridePermissionIfTrue)) || disabled">
  <label for="switch-{{id}}"></label>
</div>
